/**
 * Synterra Labs — Science
 * - Tag filter (client-side, instant)
 * - Auto-generated table of contents from H2 headings
 * - Scroll-spy on TOC entries
 * - Share buttons (Twitter, Facebook, LinkedIn, copy link, native Web Share)
 */
(function () {
  'use strict';

  /* ---------- TAG FILTER ---------- */
  function initTagFilter() {
    var filterBar = document.querySelector('[data-syn-science-filter]');
    var grid      = document.querySelector('[data-syn-science-grid]');
    var noResults = document.querySelector('[data-syn-science-no-results]');
    if (!filterBar || !grid) return;

    var cards = grid.querySelectorAll('[data-syn-science-card]');
    if (!cards.length) return;

    function setActive(filter) {
      filterBar.querySelectorAll('.syn-science__filter-btn').forEach(function (btn) {
        var match = btn.getAttribute('data-syn-filter') === filter;
        btn.classList.toggle('is-active', match);
        btn.setAttribute('aria-selected', match ? 'true' : 'false');
      });

      var visible = 0;
      cards.forEach(function (card) {
        var tags = (card.getAttribute('data-tags') || '').toLowerCase();
        var show = filter === 'all' || tags.indexOf(filter.toLowerCase() + '|') > -1;
        card.classList.toggle('is-hidden', !show);
        if (show) visible++;
      });

      if (noResults) {
        if (visible === 0 && filter !== 'all') noResults.removeAttribute('hidden');
        else noResults.setAttribute('hidden', '');
      }
    }

    filterBar.addEventListener('click', function (e) {
      var btn = e.target.closest('.syn-science__filter-btn');
      if (!btn) return;
      var filter = btn.getAttribute('data-syn-filter') || 'all';
      setActive(filter);
      // Update URL hash for sharable filter state
      if (filter === 'all') {
        history.replaceState(null, '', window.location.pathname + window.location.search);
      } else {
        history.replaceState(null, '', '#tag=' + encodeURIComponent(filter));
      }
    });

    // Initialize from URL hash if present
    var hash = window.location.hash;
    if (hash.indexOf('#tag=') === 0) {
      var initial = decodeURIComponent(hash.slice(5));
      setActive(initial);
    }

    // React to ?tag= query param (set by article tag pills linking back to overview)
    var params = new URLSearchParams(window.location.search);
    if (params.has('tag')) setActive(params.get('tag').toLowerCase());
  }

  /* ---------- TABLE OF CONTENTS ---------- */
  function slugify(str) {
    return str
      .toLowerCase()
      .normalize('NFD').replace(/[̀-ͯ]/g, '')
      .replace(/[^\w\s-]/g, '')
      .trim()
      .replace(/\s+/g, '-')
      .replace(/-+/g, '-');
  }

  function initTOC() {
    var body = document.querySelector('[data-syn-science-body]');
    var tocList = document.querySelector('[data-syn-science-toc-list]');
    var tocWrap = document.querySelector('[data-syn-science-toc]');
    if (!body || !tocList) return;

    var headings = body.querySelectorAll('h2');
    if (headings.length < 2) {
      if (tocWrap) tocWrap.setAttribute('data-empty', 'true');
      return;
    }

    var fragment = document.createDocumentFragment();
    var anchors = [];

    headings.forEach(function (h, i) {
      var text = h.textContent.trim();
      var id = h.id || slugify(text) || ('section-' + i);
      h.id = id;

      var li = document.createElement('li');
      var a = document.createElement('a');
      a.href = '#' + id;
      a.textContent = text;
      a.addEventListener('click', function (e) {
        e.preventDefault();
        var target = document.getElementById(id);
        if (target) {
          var top = target.getBoundingClientRect().top + window.pageYOffset - 90;
          window.scrollTo({ top: top, behavior: 'smooth' });
          history.replaceState(null, '', '#' + id);
        }
      });
      li.appendChild(a);
      fragment.appendChild(li);
      anchors.push({ id: id, link: a, heading: h });
    });

    tocList.appendChild(fragment);

    // Scroll-spy
    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            var id = entry.target.id;
            anchors.forEach(function (a) {
              a.link.classList.toggle('is-active', a.id === id);
            });
          }
        });
      }, { rootMargin: '-100px 0px -65% 0px', threshold: 0 });

      anchors.forEach(function (a) { observer.observe(a.heading); });
    }
  }

  /* ---------- SHARE BUTTONS ---------- */
  function initShare() {
    var bar = document.querySelector('[data-syn-science-share]');
    if (!bar) return;

    var url = window.location.href;
    var title = document.title;

    bar.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-share]');
      if (!btn) return;
      e.preventDefault();
      var type = btn.getAttribute('data-share');

      if (type === 'copy') {
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(url).then(function () {
            btn.classList.add('is-copied');
            setTimeout(function () { btn.classList.remove('is-copied'); }, 1500);
          });
        }
        return;
      }

      // Native Web Share API on mobile (if Twitter/Facebook/LinkedIn fall back)
      if (navigator.share && (type === 'native' || /iphone|ipad|android/i.test(navigator.userAgent))) {
        navigator.share({ title: title, url: url }).catch(function () { openShareWindow(type, url, title); });
        return;
      }

      openShareWindow(type, url, title);
    });

    function openShareWindow(type, u, t) {
      var encU = encodeURIComponent(u);
      var encT = encodeURIComponent(t);
      var href = '';
      switch (type) {
        case 'twitter':  href = 'https://twitter.com/intent/tweet?url=' + encU + '&text=' + encT; break;
        case 'facebook': href = 'https://www.facebook.com/sharer/sharer.php?u=' + encU; break;
        case 'linkedin': href = 'https://www.linkedin.com/sharing/share-offsite/?url=' + encU; break;
        default: return;
      }
      window.open(href, 'share', 'width=600,height=500,noopener,noreferrer');
    }
  }

  /* ---------- INIT ---------- */
  function boot() {
    initTagFilter();
    initTOC();
    initShare();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
